export const OPTION_DATE = 'BY DATE RANGE';
export const OPTION_KILL_SHEET_NUMBER = 'BY KILL SHEET NUMBER';

export const OPTION_DEFAULT = OPTION_KILL_SHEET_NUMBER;

export const OPTIONS: string[] = [
  OPTION_DATE,
  OPTION_KILL_SHEET_NUMBER,
];
